import * as React from "react";
import { Box, Container, Chip } from "@mui/material";
import { getLocalDate, getPriceCurrency, parseTextWithLinks } from "helpers/utils";
import CustomSectionCreator from "components/CustomSectionCreator";
import { H2, H4, H5 } from "components/CustomTypography";
import ButtonComponent from "components/Button";
import MockGeneralHeader from "components/elements/main/MockGeneralHeader";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import { DATE_FORMAT_SHORT } from "config/constants";

import "./style.scss";

const TryOnOrderDetail = (props) => {
  const { 
    orderDetail = {}, 
    handlePayment, 
    currency, 
    onCancel, 
    isLoadingBootInfo 
  } = props;

  const { 
    order_id, 
    package: packageInfo,
    credits,
    pricing = {},
    status,
    payment_status,
    payment_id,
    payment_method,
    created_at,
    credits_added
  } = orderDetail;

  const renderOrderInformation = () => (
    <Box ml={2} mt={2}>
      <H2 mb={2} fontSize={16}>Order # {order_id}</H2>
      <H5 fontSize={14} color="text.secondary">
        {getLocalDate(created_at, DATE_FORMAT_SHORT)}
      </H5>
      <Box mt={1}>
        <Chip 
          label={status?.toUpperCase()} 
          color={status === 'completed' ? 'success' : 'warning'}
          size="small"
        />
      </Box>
    </Box>
  );

  const renderPaymentInformation = () => (
    <Box ml={2}>
      <H2 mb={2} fontSize={16}>
        Payment Status: 
        <Chip 
          label={payment_status?.toUpperCase()} 
          color={payment_status === 'completed' ? 'success' : 'warning'}
          size="small"
          sx={{ ml: 1 }}
        />
      </H2>
      {payment_status === "pending" || payment_status === "due" ? (
        <ButtonComponent
          type="primary"
          name="Pay for Order"
          fullWidth
          onClick={handlePayment}
        />
      ) : (
        <Box>
          <H5 fontSize={14}>
            Payment ID: {payment_id}
          </H5>
          <H5 fontSize={14}>
            Method: {payment_method?.toUpperCase()}
          </H5>
        </Box>
      )}
    </Box>
  );

  const renderPackageDetails = () => (
    <Box>
      <Box className="styled-card" width="100%" display="flex" p={2}>
        <Box flexGrow={1} order={1} ml={2}>
          <H2 mb={1} fontSize={16}>
            {packageInfo?.title}
          </H2>
          <H4 fontSize={12} color="text.secondary">
            {packageInfo?.description}
          </H4>
          <Box mt={2}>
            <Chip 
              label={`${credits} Credits`} 
              color="primary" 
              size="medium"
            />
            {credits_added && (
              <Chip 
                label="Credits Added" 
                color="success" 
                size="small"
                sx={{ ml: 1 }}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );

  const renderPricingDetails = () => (
    <Box>
      <Box className="styled-card" width="100%" display="flex" p={1}>
        <Box width="80%" order={1} ml={2}>
          <H2 mb={2} fontSize={16}>Original Price:</H2>
        </Box>
        <Box width="20%" order={2} ml={2}>
          <H2 mb={2} fontSize={16}>
            {getPriceCurrency(pricing.original_price, currency)}
          </H2>
        </Box>
      </Box>

      <Box className="styled-card" width="100%" display="flex" p={1}>
        <Box width="80%" order={1} ml={2}>
          <H2 mb={2} fontSize={16}>Price:</H2>
        </Box>
        <Box width="20%" order={2} ml={2}>
          <H2 mb={2} fontSize={16}>
            {getPriceCurrency(pricing.price, currency)}
          </H2>
        </Box>
      </Box>

      {pricing.discount > 0 && (
        <Box className="styled-card" width="100%" display="flex" p={1}>
          <Box width="80%" order={1} ml={2}>
            <H2 mb={2} fontSize={16}>Discount:</H2>
          </Box>
          <Box width="20%" order={2} ml={2}>
            <H2 mb={2} fontSize={16} color="success.main">
              -{getPriceCurrency(pricing.discount, currency)}
            </H2>
          </Box>
        </Box>
      )}

      <Box className="styled-card" width="100%" display="flex" p={1}>
        <Box width="80%" order={1} ml={2}>
          <H2 mb={2} fontSize={16}>Taxes:</H2>
        </Box>
        <Box width="20%" order={2} ml={2}>
          <H2 mb={2} fontSize={16}>
            {getPriceCurrency(pricing.tax, currency)}
          </H2>
        </Box>
      </Box>

      <hr className="solid" />

      <Box className="styled-card" width="100%" display="flex" p={1}>
        <Box width="80%" order={1} ml={2}>
          <H2 mb={2} fontSize={18}>Total:</H2>
        </Box>
        <Box width="20%" order={2} ml={2}>
          <H2 mb={2} fontSize={18} color="primary">
            {getPriceCurrency(pricing.total, currency)}
          </H2>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      <ShopHeaderBack onCancel={onCancel} />
      <CustomSectionCreator isSubtle={true} title="Order Information" />
      <Container>
        <Box>
          {renderOrderInformation()}
          <hr className="solid" />
          {isLoadingBootInfo ? <MockGeneralHeader /> : renderPaymentInformation()}
          <hr className="solid" />
          <CustomSectionCreator isSubtle={true} title="Package Details" />
          {renderPackageDetails()}
          <hr className="solid" />
          <CustomSectionCreator isSubtle={true} title="Pricing Details" />
          {renderPricingDetails()}
        </Box>
      </Container>
    </div>
  );
};

export default TryOnOrderDetail;
